























































































































































































































































































































































































// --- Vue & Template imports ---
import { Component, Prop, Vue } from 'vue-property-decorator';
import BaseMaterialCard from '@/components/base/MaterialCard.vue';

// --- Models ---
import { UserProfile } from '@/models/User.model';

// --- Services ---
import AppService from '@/services/app';
import AuthService from '@/services/auth';

// --- Third Party imports ---
import VueRecaptcha from 'vue-recaptcha';
import dayjs from 'dayjs';

@Component({
  components: {
    BaseMaterialCard,
    VueRecaptcha,
  },
})

export default class PagesRegister extends Vue {

  valid: boolean = false;
  captchaVerified: boolean = false;

  user: UserProfile = {
    firstName: '',
    surname: '',
    birthDate: '',
    raceId: 0,
    race: '',
    genderId: 0,
    gender: '',
    locationId: 0,
    location: '',
    email: '',
    username: '',
    wantsNews: false,
    quote: '',
  };
  password: string = '';
  isMomentumMember: boolean = false;

  today: string = dayjs().format('YYYY-MM-DD');
  dobPicker: boolean = false;
  dateOfBirth: string = '';
  showPassword: boolean = false;
  tAndC: boolean = false;
  clicked: boolean = false;
  loader: string = '';

  rules = {
    required: (value: string) => !!value || '',
    nameSurname: (value: string) => /^[A-Za-z '-]+$/.test(value.trim()) || 'Name must only contain letters',
    idNumber: (value: string) => (value && value.length > 0) ? /^[0-9]{13}$/.test(value) || 'ID Number must be numeric and 13 characters long' : true, // TODO: @connor - (later) Check with Sean if we want to do proper SA ID Number Validation here https://codeblock.co.za/how-to-validate-a-south-african-id-number-with-php/
    optionalPhone: (value: string) => (value && value.length > 0) ? /^[0-9]{10}$/.test(value) || 'Please enter a valid Phone Number' : true,
    email: (value: string) => /(?:[a-zA-Z0-9!#$%&'*+/=?^_{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/.test(value) || 'E-mail must be valid',
    username: (value: string) => /^(?=.*[a-zA-Z0-9- _.@])[a-zA-Z0-9- _.@]+$/.test(value) || 'Remove invalid characters',
    password: (value: string) => value.length >= 8 || 'At least 8 characters',
  };

  // Functions

  async beforeMount() {
    // get all our static data from the DB
    await AppService.getGenders(false);
    await AppService.getRaces(false);
    await AppService.getLocations(false);
  }

  getSiteKey() {
    return process.env.VUE_APP_GCAPTCHA_SITE_KEY;
  }

  resetCaptchaVerified() {
    this.captchaVerified = false;
  }

  verifyCaptcha(response: string) {
    this.captchaVerified = true;
  }

  setBirthDate() {
    if (this.user.idNumber) {
      // use the first 6 digits of the ID Number
      let prefix = '19';
      if ( parseInt(this.user.idNumber!.substring(0, 2), 10) < parseInt(dayjs().format('YY'), 10)) {
        // young 'un
        prefix = '20';        
      }

      this.user.birthDate = dayjs( prefix + this.user.idNumber!.substring(0, 6), 'YYYYMMDD').format('YYYY-MM-DD');
      this.dateOfBirth = this.user.birthDate;
    }
  }

  async register() {
    this.clicked = true;
    this.loader = 'clicked';

    try {

      // because these users are not necessarily computer literate, we are letting them click the register button
      // anytime, and then we need to show them their errors
      if (!this.valid) {
        if (this.$refs.registerForm) {
          (this.$refs.registerForm as any).validate();
        }
      } else if (!this.tAndC) {
        AppService.errorHandler('Please accept the Terms and Conditions');
      } else if (!this.captchaVerified) {
        AppService.errorHandler('Please complete the Captcha Verification');
      } else {
        // they passed! Let's submit their form now
        const response = await AuthService.register({ partnerDomain: process.env.VUE_APP_SUBDOMAIN, firstName: this.user.firstName, 
          surname: this.user.surname, idNumber: this.user.idNumber, birthDate: this.user.birthDate, raceId: this.user.raceId, 
          genderId: this.user.genderId, locationId: this.user.locationId, cell: this.user.cell, email: this.user.email, 
          username: this.user.username, password: this.password, isMomentumMember: this.isMomentumMember, wantsNews: this.user.wantsNews });

        if (response.data.result === 'false') {
          AppService.errorHandler(response.data.message);
        } else {
          AppService.successHandler(response.data.message);
          this.$router.push({ name: 'Register More' });
        }
      }

    } catch (error) {
      if (error.response) {
        AppService.errorHandler(error.response.statusText);
      } else {
        AppService.errorHandler(this.$store.getters['app/messages'].couldNotConnect);
      }

    } finally {
      this.clicked = false;
      this.loader = '';
    }
  }
}
